declare const __VINEFORECAST_ENV__: Record<string, string | undefined>

declare global {
  interface Window {
    __VINEFORECAST_ENV__?: Record<string, string | undefined>,
  }
}

type ProcessShape = {
  env: Record<string, string | undefined>,
}

const resolvedEnvironment = typeof window === 'undefined'
  ? __VINEFORECAST_ENV__
  : window.__VINEFORECAST_ENV__ || __VINEFORECAST_ENV__

const existingProcess = globalThis.process as ProcessShape | undefined

if (!existingProcess) {
  Object.defineProperty(globalThis, 'process', {
    value: { env: resolvedEnvironment },
    configurable: true,
    writable: true,
  })
} else {
  existingProcess.env = {
    ...existingProcess.env,
    ...resolvedEnvironment,
  }
}

export default resolvedEnvironment
